/**
 * 统一的图表样式配置
 */

// 图表尺寸配置
export const CHART_DIMENSIONS = {
  // 默认最小高度
  minHeight: 600,
  // 默认高度
  defaultHeight: 700,
  // 全屏高度
  fullscreenHeight: 'calc(100vh - 200px)',
  // 边距
  margin: {
    top: 40,
    right: 40,
    bottom: 40,
    left: 40
  }
};

// SVG样式配置
export const SVG_STYLES = {
  default: {
    width: '100%',
    minHeight: CHART_DIMENSIONS.minHeight,
    backgroundColor: '#ffffff',
    border: '1px solid #f0f0f0',
    borderRadius: '4px',
    padding: '16px'
  },
  container: {
    width: '100%',
    height: '100%',
    overflow: 'auto'
  }
};

// Mermaid图表配置
export const MERMAID_CONFIG = {
  startOnLoad: true,
  theme: 'default' as const,
  securityLevel: 'loose' as const,
  flowchart: {
    useMaxWidth: true,
    htmlLabels: true,
    curve: 'basis' as const,
    padding: 30,
    nodeSpacing: 80,
    rankSpacing: 80,
    defaultRenderer: 'dagre-wrapper' as const,
    diagramPadding: 20
  },
  themeVariables: {
    primaryColor: '#e6f7ff',
    primaryTextColor: '#1890ff',
    primaryBorderColor: '#91d5ff',
    lineColor: '#91d5ff',
    secondaryColor: '#f6ffed',
    secondaryTextColor: '#52c41a',
    secondaryBorderColor: '#b7eb8f',
    tertiaryColor: '#fff7e6',
    tertiaryTextColor: '#fa8c16',
    tertiaryBorderColor: '#ffd591',
    background: '#ffffff',
    mainBkg: '#e6f7ff',
    secondBkg: '#f6ffed',
    tertiaryBkg: '#fff7e6',
    primaryBoxBkg: '#e6f7ff',
    primaryBoxTxtColor: '#003a8c',
    nodeBorder: '#1890ff',
    clusterBkg: '#fffbe6',
    clusterBorder: '#faad14',
    defaultLinkColor: '#91d5ff',
    titleColor: '#262626',
    edgeLabelBackground: '#ffffff',
    fontSize: '16px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial'
  }
};

// D3.js力导向图配置
export const D3_FORCE_CONFIG = {
  charge: -400,
  linkDistance: 150,
  collisionRadius: 50,
  alphaDecay: 0.02,
  velocityDecay: 0.4
};

// 节点样式配置
export const NODE_STYLES = {
  entity: {
    width: 180,
    height: 80,
    rx: 8,
    fill: '#e6f7ff',
    stroke: '#1890ff',
    strokeWidth: 2
  },
  valueObject: {
    width: 160,
    height: 70,
    rx: 6,
    fill: '#f6ffed',
    stroke: '#52c41a',
    strokeWidth: 2
  },
  aggregate: {
    width: 200,
    height: 90,
    rx: 10,
    fill: '#fff7e6',
    stroke: '#fa8c16',
    strokeWidth: 2
  },
  service: {
    width: 180,
    height: 80,
    rx: 8,
    fill: '#f9f0ff',
    stroke: '#722ed1',
    strokeWidth: 2
  }
};

// 连线样式配置
export const LINK_STYLES = {
  default: {
    stroke: '#999',
    strokeWidth: 2,
    strokeOpacity: 0.6
  },
  arrow: {
    width: 10,
    height: 10,
    refX: 15,
    refY: 0,
    viewBox: '0 -5 10 10',
    markerWidth: 10,
    markerHeight: 10,
    orient: 'auto'
  }
};

// 文字样式配置
export const TEXT_STYLES = {
  title: {
    fontSize: '16px',
    fontWeight: 'bold',
    fill: '#262626'
  },
  label: {
    fontSize: '14px',
    fill: '#595959'
  },
  description: {
    fontSize: '12px',
    fill: '#8c8c8c'
  }
};